import { Data, FieldType, Form, FormField, Modal, ModalId, Option, useUIActions, useUIState } from '../../../../../features/ui'
import { define } from '../../../../../utils/typeUtils'
import { useEffect, useState } from 'react'

type Props = {
    options: Option[]
    onSubmit: (province: string) => void
}

export const IIBBProvinceFormModal = ({ options, onSubmit }: Props) => {
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()
    const { toggleModal } = useUIActions()

    useEffect(() => setKey(current => current + 1), [openedModal])

    const fields: FormField[] = [{
        name: 'province',
        type: FieldType.SELECT,
        options,
        placeholder: 'Seleccionar provincia',
        validate: data => data.province ? null : 'Seleccionar una provincia'
    }]

    const handleSubmit = (data: Data) => {
        onSubmit(define(data.province) as string)
        toggleModal(ModalId.IIBB_PROVINCE_FORM)
    }

    return (
        <Modal modalId={ModalId.IIBB_PROVINCE_FORM} title="Agregar provincia" widthSize="m" actions={[]}>
            <Form
                key={key}
                formId="iibb-province-form"
                fields={fields}
                createLabel="Confirmar"
                onSubmit={handleSubmit}
                onCancel={() => toggleModal(ModalId.IIBB_PROVINCE_FORM)}
            />
        </Modal>
    )
}
